import validate from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/middleware/auth.global.ts";
import manifest_45route_45rule from "/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}